import { AxiosError, AxiosRequestConfig } from 'axios';
import { IBlogCategories, IblogPostListingCardData, IInfoEditBlog, IUpdateRol, IUserDetail } from '../types/blog';
import { apiDelete, apiGet, apiPost, apiPut } from './api';

const { REACT_APP_NUDOS_API, REACT_APP_ORGANIZATION, REACT_APP_API_USERS } = process.env;

const getBlogList = async (query?: string): Promise<IblogPostListingCardData[]> => {
  const queryParam = query ? `?find=${query}` : '';
  return apiGet<AxiosRequestConfig, IblogPostListingCardData[]>(`${REACT_APP_NUDOS_API}/post${queryParam}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const deleteBlogEntry = async (postId: string | number, userId: string | number): Promise<unknown> => {
  return apiDelete<AxiosRequestConfig, unknown>(`${REACT_APP_NUDOS_API}/post/delete/${postId}/${userId}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const getCategories = async (): Promise<IBlogCategories[]> => {
  return apiGet<AxiosRequestConfig, IBlogCategories[]>(`${REACT_APP_NUDOS_API}/category`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const addCategory = async (name: string): Promise<IBlogCategories> => {
  return apiPost<AxiosRequestConfig, unknown>(`${REACT_APP_NUDOS_API}/category`, { name })
    .then(resp => {
      const respEdit: IBlogCategories = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const getUserDetail = async (userId: number): Promise<IUserDetail> => {
  return apiGet<AxiosRequestConfig, IUserDetail>(`${REACT_APP_ORGANIZATION}/organization/author/${userId} `)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const updatePhoto = async (userId: number, photo: FormData): Promise<string> => {
  return apiPut<AxiosRequestConfig, FormData>(`${REACT_APP_API_USERS}/user/backoffice/profile-photo/${userId}`, photo)
    .then(resp => {
      const respEdit: string = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const blogDetail = async (blogId: number | string): Promise<IInfoEditBlog> => {
  return apiGet<AxiosRequestConfig, IInfoEditBlog>(`${REACT_APP_NUDOS_API}/post/backoffice/${blogId}`)
    .then(response => Promise.resolve(response))
    .catch((error: AxiosError) => Promise.reject(error));
};

const addBlog = async (body: FormData): Promise<string> => {
  return apiPost<AxiosRequestConfig, FormData>(`${REACT_APP_NUDOS_API}/post`, body)
    .then(resp => {
      const respEdit: string = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

const editBlog = async (userId: number | string, blogId: number | string, body: FormData): Promise<string> => {
  return apiPut<AxiosRequestConfig, FormData>(`${REACT_APP_NUDOS_API}/post/update/${blogId}/${userId}`, body)
    .then(resp => {
      const respEdit: string = resp;
      return respEdit;
    })
    .catch((error: AxiosError) => Promise.reject(error));
};

export {
  getBlogList,
  deleteBlogEntry,
  getCategories,
  addCategory,
  getUserDetail,
  updatePhoto,
  blogDetail,
  addBlog,
  editBlog
};
